import { render, staticRenderFns } from "./RelationCompletion.vue?vue&type=template&id=368d5832&scoped=true&"
import script from "./RelationCompletion.vue?vue&type=script&lang=js&"
export * from "./RelationCompletion.vue?vue&type=script&lang=js&"
import style0 from "./RelationCompletion.vue?vue&type=style&index=0&id=368d5832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d5832",
  null
  
)

export default component.exports